import { ChevronLeft as ArrowBackIosIcon, ChevronRight as ArrowForwardIosIcon } from "lucide-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { KRUMAGO } from "../../../s3-assets/Krumago";

const Carousel = () => {

    const contents = useSelector((state) => state.companyReducer.company?.contents || []);

    const heroImage = contents.find(
        (c) =>
            c.contentType === "IMAGE" &&
            Array.isArray(c.tags) &&
            c.tags.some(tag => tag.name?.toLowerCase() === "hero section")
    )?.displayLink;

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = useMemo(
        () => [heroImage || KRUMAGO.IMAGES.BANNER_1, KRUMAGO.IMAGES.BANNER_1, KRUMAGO.IMAGES.BANNER_2],
        [heroImage]
    );

    const nextImage = useCallback(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, [images.length]);

    const prevImage = useCallback(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
    }, [images.length]);

    useEffect(() => {
        const interval = setInterval(nextImage, 3000);
        return () => clearInterval(interval);
    }, [nextImage]);

    return (
        <div className="relative overflow-hidden rounded-lg">
            <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}
            >
                {images.map((src, index) => (
                    <img
                        loading="lazy"
                        key={index}
                        src={src}
                        alt={`Carousel ${index}`}
                        className="w-full h-auto flex-shrink-0"
                        style={{ height: "460px", width: "100%", objectFit: "cover", objectPosition: "center" }}
                    />
                ))}
            </div>
            <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
                {images.map((_, i) => (
                    <span
                        key={i}
                        className={`block h-1 cursor-pointer rounded-2xl transition-all ${currentImageIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"}`}
                        onClick={() => setCurrentImageIndex(i)}
                    />
                ))}
            </div>
            <button
                className="absolute top-1/2 transform -translate-y-1/2 left-2 bg-white bg-opacity-50 p-1 sm:p-2 rounded-full"
                onClick={prevImage}
            >
                <ArrowBackIosIcon fontSize="large" />
            </button>
            <button
                className="absolute top-1/2 transform -translate-y-1/2 right-2 bg-white bg-opacity-50 p-1 sm:p-2 rounded-full"
                onClick={nextImage}
            >
                <ArrowForwardIosIcon fontSize="large" />
            </button>
        </div>
    );
};

export default Carousel;
